import React from "react";
import {message, Skeleton} from "antd";
import {addQa, getQaDetail, updateQa} from "../../../action/qa_action";
import QaForm from "../../../component/qa-form";

class QaDetail extends React.Component{
    static STATE_STRUCT = () => {
        return {
            uploadLoading: false,
            loading: false,
            formDefaultValue: null,
        }
    };

    state = QaDetail.STATE_STRUCT();

    componentDidMount() {
        if (this.props.match.params.id){
            this._getData(this.props.match.params.id);
        }
    }

    _getData = (id) => {
        this.setState({loading: true});
        getQaDetail(id, (res, msg) => {
            if (res){
                this.setState({formDefaultValue: res});
            }else{
                message.error(msg ? msg : "获取Qa详情失败");
                this.props.history.push("/qa");
            }
        });
    };

    _createForm = () =>
        (<QaForm defaultFormValue={this.state.formDefaultValue} onUpload={(values)=>{
            this.setState({uploadLoading: true});
            if(this.props.match.params.id){
                values.id = this.props.match.params.id;
                updateQa(values, (res, msg) => {
                    this.setState({uploadLoading: false});
                    if (res){
                        this.props.history.push("/qa");
                    }else
                        message.error(msg ? msg : "更新Qa失败");
                })
            }else{
                addQa(values, (res, msg) => {
                    this.setState({uploadLoading: false});
                    if (res){
                        this.props.history.push("/qa");
                    }else
                        message.error(msg ? msg : "添加Qa失败");
                });
            }
        }} loading={this.state.uploadLoading} />);

    render() {
        return (
            <Skeleton loading={this.props.loading}>
                <div>
                    <span style={{fontSize: 30, fontWeight: 500, color: "black", lineHeight: "70px"}}>
                        {
                            this.props.match.params.id ? '更新Qa' : '添加Qa'
                        }
                    </span>
                    {
                        this.props.match.params.id ? (this.state.formDefaultValue ? this._createForm() : <br/>) : this._createForm()
                    }
                </div>
            </Skeleton>
        );
    }
}

export default QaDetail;
